import * as actionType from '../actionTypes';

const initialState = {
    eligibilty: '',
    ifsc: '',
    paymentd2c: '',
    proposalDetails: ''
}
const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.PAYMENT_CHECK:
            return {
                ...state,
                eligibilty: action.data
            };
       /* case actionType.PAYMENT_REMAINING:
            return {
                ...state,
                paymentDetails: action.data
            };*/
        case actionType.IFSC_PAYMENT:
            return {
                ...state,
                ifsc: action.data && action.data.body
            };
        case actionType.PAYMENT_D2C_OFFLINE:
            return {
                ...state,
                paymentd2c: action.data && action.data.body
            }
        case actionType.FETCH_PROPOSAL_DETAIL:
            return {
                ...state,
                proposalDetails: action.data
            }
        default:
            return state
    }
}
export default paymentReducer;
